import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const OurProduct = () => {
const location = useLocation();
const searchParams = new URLSearchParams(location.search);
const category = searchParams.get('category');

let pageTitle = 'Our Products';

if (category === 'firewall') {
pageTitle = 'Firewall / Routers';
} else if (category === 'switches') {
pageTitle = 'Switches';
} else if (category === 'infrastructure') {
pageTitle = 'Network Infrastructures';
}

const products = [
{
name: 'IndyaNet Edge Small',
description: 'For High Performance, Desktop Form Factor',
image:
'https://img1.wsimg.com/isteam/ip/a27d2dc3-82db-4815-b271-215705ee1c2c/edge%20small%20jpg.jpg/:/cr=t:25%25,l:0%25,w:100%25,h:50%25/rs=w:388,h:194,cg:true',
link: '/products/indyanet-edge-small',
},
{
name: 'IndyaNet Edge Mini',
description: 'For Small Branches, Desktop Form Factor',
image:
'https://img1.wsimg.com/isteam/ip/a27d2dc3-82db-4815-b271-215705ee1c2c/edge%20mini%20jpg.jpg/:/cr=t:0%25,l:0%25,w:100%25,h:100%25/rs=w:388,h:194,cg:true',
link: '/products/indyanet-edge-mini',
},
{
name: 'IndyaNet Edge Atom',
description: 'Edge Gateway, For Small Branches',
image:
'https://img1.wsimg.com/isteam/ip/a27d2dc3-82db-4815-b271-215705ee1c2c/Untitled%20design%20(6).jpg/:/cr=t:0%25,l:0%25,w:100%25,h:100%25/rs=w:388,h:194,cg:true',
link: '/products/indyanet-edge-atom',
},
{
name: 'IndyaNet Edge 1L',
description: 'For Medium Branches, Desktop Form Factor',
image:
'https://img1.wsimg.com/isteam/ip/a27d2dc3-82db-4815-b271-215705ee1c2c/Edge%201l.jpg/:/cr=t:25%25,l:0%25,w:100%25,h:50%25/rs=w:388,h:194,cg:true',
link: '/products/indyanet-edge-1l',
},
{
name: 'Multi-WAN Gigabit VPN Router',
description: 'GWN7001, GWN7002, GWN7003',
image:
'https://img1.wsimg.com/isteam/ip/a27d2dc3-82db-4815-b271-215705ee1c2c/Multiwan%20gigabit.jpg/:/cr=t:0%25,l:0%25,w:100%25,h:100%25/rs=w:388,cg:true',
link: '/products/multi-wan-gigabit-vpn',
},
{
name: 'Multi-WAN Gigabit VPN Router',
description: 'GWN7002',
image:
'https://img1.wsimg.com/isteam/ip/a27d2dc3-82db-4815-b271-215705ee1c2c/GWN7002%20(1).jpg/:/cr=t:0%25,l:0%25,w:100%25,h:100%25/rs=w:388,h:194,cg:true',
link: '/products/multi-wan-gigabit-vpn',
},
];

const switchProducts = [
  {
    name: 'GWN7711',
    description: 'Layer 2 Lite Managed Network Switch',
    image: 'https://www.grandstream.com/hubfs/GWN7711(P)_2.png',
    link: '/products/gwn7711',
  },
  {
    name: 'GWN7711P',
    description: 'Layer 2 Lite Managed PoE Network Switch',
    image: 'https://www.grandstream.com/hubfs/GWN7711(P)_3.png',
    link: '/products/gwn7711p',
  },
  {
    name: 'GWN7700 Series',
    description: 'Unmanaged Gigabit Network Switch',
    image: 'https://www.grandstream.com/hubfs/GWN7702%2c7702P%2c7703%2c7706%20Combo.png',
    link: '/products/gwn7700-series',
  },
  {
    name: 'GWN7800 Series',
    description: 'Layer 2+ Managed Network Switch',
    image: 'https://www.grandstream.com/hubfs/GWN7800%20Series%20Website%20Pic%207.png',
    link: '/products/gwn7800-series',
  },
  {
    name: 'GWN7806(P)',
    description: 'Enterprise-Grade Layer 2+ Managed Network Switch',
    image: 'https://www.grandstream.com/hubfs/Product%20Images/GWN7806/GWN7806%20Website%20Image%20-%201.png',
    link: '/products/gwn7806p',
  },
  {
    name: 'GWN7810 Series',
    description: 'Enterprise Layer 3 Managed Network Switch',
    image: 'https://www.grandstream.com/hubfs/GWN781X%204%20Website%20Upload.png',
    link: '/products/gwn7810-series',
  },
];

const infrastructureProducts = [
  {
    name: 'Network Rack',
    description: 'Available in 2U & 4U Sizes',
    image: 'https://m.media-amazon.com/images/I/51D2sy9ZnRL._SX450_.jpg',
    link: '/products/network-rack',
  },

   {
    name: 'CAT6 UTP Patch Panel',
    description: 'Available in 8 / 16 / 24 Port',
    image: 'https://iconicitstore.com/wp-content/uploads/2021/12/d-link-cat6-utp-24-port-loaded-patch-panel-cat6-24-port-panel-500x500-1.jpg',
    link: '/products/cat6-utp-patch-panel',
  },

  {
    name: 'Face Plate',
    description: 'Available in 1 / 2 / 4 Port',
    image: 'https://its.dlink.co.in/assets/ppic_1509456303.png',
    link: '/products/face-plate',
  },

  {
    name: 'RJ45 Connector Plug',
    description: 'Pack of 100 RJ45 Modular Plugs',
    image: 'https://m.media-amazon.com/images/I/41cyX0hwAjS.jpg',
    link: '/products/rj45-connector-plug',
  },

  {
  name: 'CAT6 Networking Cable',
  description: 'High-Speed Ethernet Cable',
  image: 'https://encrypted-tbn1.gstatic.com/shopping?q=tbn:ANd9GcSWfYMu2TdO6e4_Ldf-J4GpvS02omrcGrNfllyCSGP2QYbQmArmfalviIytevW2qAwJjXzxsMihTM2Cd-rfmghypos6iIcg',
  link: '/products/cat6-networking-cable',
},

{
  name: 'CAT6 Patch Cord',
  description: 'High-Speed RJ45 Ethernet Patch Cable',
  image: 'https://m.media-amazon.com/images/I/61wy4EqaA9L._SY450_.jpg',
  link: '/products/cat6-patch-cord',
},

{
  name: 'CP Plus 8 Channel 4K Network Video Recorder',
  description: 'CP-UNR-4K2081-V4 (8 Ch. 4K NVR)',
  image: 'https://m.media-amazon.com/images/I/61gek7+PdGL._AC_UF1000,1000_QL80_.jpg',
  link: '/products/cp-plus-8ch-nvr',
},

{
  name: 'CP Plus 8 Channel Digital Video Recorder',
  description: 'CP-UVR-0801F1V-I (8 Ch. 1080P DVR)',
  image: 'https://cpplusworld.com/prodassets/product/small/79c341f5-076e-46d7-84ac-f0f57ed37c53.png',
  link: '/products/cp-plus-8ch-dvr',
},

{
  name: 'CP PLUS 3MP Smart Wi-Fi CCTV Camera',
  description: 'CP-E31Q | 360° View | Motion Tracking | 2-Way Talk',
  image: 'https://m.media-amazon.com/images/I/51e58RA-akL._SX679_.jpg',
  link: '/products/cp-plus-3mp-wifi-camera',
},

{
  name: 'RJ45 Network Cable Crimping Tool',
  description: 'Heavy-Duty Multi-Functional RJ45 Ethernet Crimper',
  image: 'https://m.media-amazon.com/images/I/61w0I3nx9yL._SX569_.jpg',
  link: '/products/rj45-network-crimping-tool',
},

{
  name: 'CP PLUS Full HD 1080P Security Camera',
  description: 'Indoor Security Camera | Clear Night Vision | 1 Channel',
  image: 'https://rukminim2.flixcart.com/image/1366/1366/xif0q/home-security-camera/0/t/b/1-cp-usc-da24l2-indoor-security-camera-cp-plus-original-imahhxwmtxhsbhpn.jpeg?q=90',
  link: '/products/cp-plus-full-hd-security-camera',
},

{
  name: 'LAN Cable Tester with Wire Tracker',
  description: 'RJ11/RJ45 Network Cable Tester & Line Finder Kit',
  image: 'https://m.media-amazon.com/images/I/71ky4z1FoYL._SX466_.jpg',
  link: '/products/lan-cable-tester-wire-tracker',
},
];

return ( <div className="min-h-screen">
{/* Hero Section */} <section className="bg-gradient-to-r from-red-600 to-red-700 text-white py-20"> <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center"> <h1 className="text-4xl md:text-5xl font-bold mb-6">
{pageTitle} </h1> <p className="text-xl text-red-100">
Discover M2M Network Solutions for seamless enterprise connectivity </p> </div> </section>

  {(category === null || category === 'firewall') ? (
    <section className="py-16 bg-gray-100 relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-5 pointer-events-none"
        style={{
          backgroundImage:
            'url(https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=1600&q=80)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      ></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product, index) => (
            <Link
              key={index}
              to={product.link}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 group border border-gray-100"
            >
              <div className="h-56 bg-gradient-to-br from-gray-50 to-gray-100 overflow-hidden flex items-center justify-center p-4">
                <img
                  src={product.image}
                  alt={product.name}
                  className="max-w-full max-h-full object-contain group-hover:scale-110 transition-transform duration-500"
                />
              </div>

              <div className="p-6 border-t border-gray-100">
                <h3 className="text-xl font-semibold mb-2 text-gray-900 group-hover:text-red-600 transition-colors">
                  {product.name}
                </h3>
                <p className="text-gray-600 text-sm">
                  {product.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>


  ) : category === 'switches' ? (
  <section className="py-16 bg-gray-100 relative overflow-hidden">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {switchProducts.map((product, index) => (
          <Link
            key={index}
            to={product.link}
            className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 group border border-gray-100"
          >
            <div className="h-56 bg-gradient-to-br from-gray-50 to-gray-100 overflow-hidden flex items-center justify-center p-4">
              <img
                src={product.image}
                alt={product.name}
                className="max-w-full max-h-full object-contain group-hover:scale-110 transition-transform duration-500"
              />
            </div>

            <div className="p-6 border-t border-gray-100">
              <h3 className="text-xl font-semibold mb-2 text-gray-900 group-hover:text-red-600 transition-colors">
                {product.name}
              </h3>
              <p className="text-gray-600 text-sm">
                {product.description}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  </section>

) : category === 'infrastructure' ? (
<section className="py-16 bg-gray-100 relative overflow-hidden">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">

            {infrastructureProducts.map((product, index) => (

                <Link
                    key={index}
                    to={product.link}
                    className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 group border border-gray-100"
                >

                    <div className="h-56 bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4 overflow-hidden">

                        <img
                            src={product.image}
                            alt={product.name}
                            className="max-w-full max-h-full object-contain group-hover:scale-110 transition-transform duration-500"
                        />

                    </div>

                    <div className="p-6 border-t border-gray-100">

                        <h3 className="text-xl font-semibold text-gray-900 group-hover:text-red-600 transition-colors mb-2">
                            {product.name}
                        </h3>

                        <p className="text-gray-600">
                            {product.description}
                        </p>

                    </div>

                </Link>

            ))}

        </div>

    </div>
</section>

): null}

  {/* Connect With Us */}
  <section className="py-12 bg-white">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <h2 className="text-3xl font-bold mb-6 text-gray-900">
        Connect With Us
      </h2>
      <p className="text-lg text-gray-700">
        Have questions about our products? Get in touch with our team for
        personalized recommendations.
      </p>
    </div>
  </section>
</div>


);
};

export default OurProduct;
